import axios, { AxiosRequestConfig } from "axios";
import { AuthLogout } from "../cloud/gcp/login";
import store, { RootState } from "../store";
import { auth } from "../cloud/gcp/config";

const url = process.env.REACT_APP_URL;

const config: AxiosRequestConfig = {
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
  },
};

const defaultApiClient = axios.create(config);

defaultApiClient.interceptors.request.use(async (req) => {
  await auth.authStateReady();
  const state = store.getState() as RootState;
  const user = state.auth.User;

  if (user) {
    console.log("user is ", user.uid);
    const jwt = await user.getIdToken();
    req.headers = { ...req.headers, Authorization: `Bearer ${jwt}` };
    console.log("req");
    return req;
  } else {
    console.log("logout");
    await AuthLogout();
    window.location.replace("/login");
    return Promise.reject(new Error("User not authenticated"));
  }
});

axios.interceptors.response.use(undefined, async (error) => {
  await auth.authStateReady();
  if (error.response?.status === 401) {
    await AuthLogout();
    window.location.replace("/login");
  }
  return Promise.reject(error);
});

export default defaultApiClient;
